import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import {
    ngRouterStateUpdatedAction,
    RouterState
} from '@classifieds-sell/state';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';

@Injectable()
export class RouterToStoreLinkService {
    constructor(private _router: Router, private store: Store<RouterState>) {}

    init() {
        this._router.events
            .pipe(filter((e) => e instanceof NavigationEnd))
            .subscribe({
                next: (e) => {
                    if (e instanceof NavigationEnd) {
                        const currentUrl = e.urlAfterRedirects;
                        const queryParams = this._router.parseUrl(currentUrl).queryParams;
                        this.store.dispatch(
                        ngRouterStateUpdatedAction({
                            event: <NavigationEnd>e,
                            queryParams: queryParams
                         })
                        )
                    }
                }
            });
    }
}
